<template>
  <div class="people">
    <div class="person" v-for="item in accountStore.getTeamInitials">
      {{ item }}
    </div>
    <NuxtLink to="/account/team/" v-if="props.showAdd" class="person add">
      +
    </NuxtLink>
  </div>
</template>

<script setup>
const props = defineProps({
  showAdd: {
    type: Boolean,
    default: false
  }
})

const accountStore = useAccountStore()
</script>

<style lang="scss" scoped>
.people {
  display: flex;
  padding-right: 7px;
  line-height: 100%;
}

.person {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  border-radius: 40px;
  border: 1px solid var(--Block-bg, #fff);
  background: var(--bubble-10, rgba(0, 0, 0, 0.1));
  backdrop-filter: blur(10px);
  width: 30px;
  height: 30px;
  padding-top: 1px;
  padding-left: 1px;
  margin-right: -7px;

  &.add {
    margin-left: 10px;
  }
}
</style>
